import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@tellescope/ui";
import type { PortalBranding } from "@tellescope/types-models";
import { useTranslation } from "react-i18next";

export type ConfigurationTarget = { type: "default" } | { type: "branding"; brandingId: string; brandingTitle: string };

interface ConfigurationSelectorProps {
  brandings: PortalBranding[];
  value: ConfigurationTarget;
  onChange: (target: ConfigurationTarget) => void;
  disabled?: boolean;
}

export const ConfigurationSelector: React.FC<ConfigurationSelectorProps> = ({
  brandings,
  value,
  onChange,
  disabled,
}) => {
  const { t } = useTranslation();

  const handleValueChange = (selectedValue: string) => {
    if (selectedValue === "default") {
      onChange({ type: "default" });
    } else {
      const branding = brandings.find((b) => b.id === selectedValue);
      if (branding) {
        onChange({ type: "branding", brandingId: branding.id, brandingTitle: branding.title });
      }
    }
  };

  const currentValue = value.type === "default" ? "default" : value.brandingId;

  return (
    <Select value={currentValue} onValueChange={handleValueChange} disabled={disabled}>
      <SelectTrigger className="w-[140px] h-7 text-xs">
        <SelectValue placeholder={t("Select configuration")} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="default">{t("Default Portal")}</SelectItem>
        {brandings.map((branding) => (
          <SelectItem key={branding.id} value={branding.id}>
            {branding.title}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
